import Header from '../components/Header.jsx';
import { bio } from '../data/bio.js';
import { useLanguage } from '../hooks/useLanguage.jsx';

export default function BioPage() {
  const { t } = useLanguage();
  const paragraphs = t(bio.text);

  return (
    <div className="page bio-page">
      <Header />
      <div className="bio-hero" aria-hidden>
        <div className="bio-hero-inner">
          <img src="./images/bio/Portrait_bio.jpg" alt={bio.name} className="bio-hero-portrait" />
        </div>
      </div>
      <main className="main-content">
        <section className="bio-section">
          <div className="bio-header">
            <div>
              <h1>{bio.name}</h1>
              <p className="bio-role">{t(bio.role)}</p>
            </div>
          </div>
          <div className="bio-text">
            {(Array.isArray(paragraphs) ? paragraphs : []).map((paragraph, index) => {
              const parts = paragraph.split('[[DESKTOP_BREAK]]');
              return (
                <p key={index}>
                  {parts.map((part, partIndex) => (
                    <span key={partIndex}>
                      {part}
                      {partIndex < parts.length - 1 && (
                        <span className="desktop-break" aria-hidden="true">
                          <br />
                        </span>
                      )}
                    </span>
                  ))}
                </p>
              );
            })}
          </div>
            <div className="bio-workshop">
            <div className="workshop-grid">
              {bio.workshopImages.map((src, index) => (
                <img key={src + index} src={src} alt="Atelier" />
              ))}
            </div>
          </div>
          <div className="bio-contact">
            <p className="bio-address">{bio.contact.address}</p>
            <p>
              <a href={`mailto:${bio.contact.email}`}>{bio.contact.email}</a>
            </p>
            <p>
              <a href={`tel:${bio.contact.phone}`}>{bio.contact.phone}</a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
